export const SET_PROMO_VALUE = 'SET_PROMO_VALUE';

export const setPromoValue = (payload) => {
  return {
    type: SET_PROMO_VALUE,
    payload,
  };
};
